import dayjs from "dayjs";
import * as de from "dayjs/locale/de";
import * as en from "dayjs/locale/en";
import * as enGB from "dayjs/locale/en-gb";
import * as es from "dayjs/locale/es";
import * as esMX from "dayjs/locale/es-mx";
import * as fr from "dayjs/locale/fr";
import { kebabCase } from "lodash";

export const locales = {
    en: en,
    "en-us": en,
    "en-gb": enGB,

    es: es,
    "es-es": es,
    "es-mx": esMX,

    fr: fr,
    de: de,
};

export const localizeDayjs = async (code: string) => {
    const locale = kebabCase(code).toLowerCase() as keyof typeof locales;

    try {
        dayjs.locale(locale);
    } catch (error) {
        console.error("Error loading dayjs locale:", error);
    }
};
